import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getFullDateTime } from '../../../../../config/utils/dateHelpers';
import { MONEY_COLLECTION_TRADER_TYPE_LABEL } from '../../../../../interfaces/moneyCollection.interface';
import { CustomerReportResponse } from '../../../../../interfaces/reports.interface';
import { getCustomerVatNumberForMyData } from '../../../../../services/utils/myDataUtils';
import { CustomerReportView } from './CustomerReportView';

interface Props {
  data: CustomerReportResponse;
}

export const CustomerReportTable = ({ data }: Props) => {
  const { t } = useTranslation();

  const getCustomerSection = useCallback(() => {
    return (
      <div className="flex-space-between-center-row-wrap width-100 padding-t-20">
        <div className="flex-center-start-column-nowrap width-200px">
          <div className="flex-start-start-row-nowrap">
            <div className="boldText3 padding-r-4">{t('PDF.TRADER')}</div>
            <div className="normalText3">
              ({t(`PDF.${MONEY_COLLECTION_TRADER_TYPE_LABEL[data?.params?.traderType || 1]}`)})
            </div>
          </div>
          <div className="normalText3">{data?.params?.customer?.companyName}</div>
        </div>
        <div className="flex-center-center-column-nowrap width-200px">
          <div className="boldText3">{t('PDF.DATE_LOWER')}</div>
          <div className="normalText3">{getFullDateTime(data?.params?.createdAt)}</div>
        </div>
        <div className="flex-center-end-column-nowrap width-200px">
          <div className="boldText3">{t('PDF.VAT_NUMBER')}</div>
          <div className="normalText3">{getCustomerVatNumberForMyData(data?.params?.customer)}</div>
        </div>
      </div>
    );
  }, [
    data?.params?.createdAt,
    data?.params?.customer?.companyName,
    data?.params?.customer?.vatNumber,
    data?.params?.traderType,
    t,
  ]);

  const getParamsSection = useCallback(() => {
    return (
      <div className="flex-space-between-center-row-wrap width-100 padding-t-20">
        <div className="flex-center-start-column-nowrap width-200px">
          {data?.params?.includeMoneyCollection && <div className="boldText3">{t('PDF.WITH_MONEY_COLLECTION')}</div>}
        </div>
        <div className="flex-center-center-column-nowrap width-200px">
          <div className="boldText3">
            {t('PDF.START_DATE')} - {t('PDF.END_DATE')}
          </div>
          <div className="normalText3">
            {data?.params?.start} - {data?.params?.end}
          </div>
        </div>
        <div className="flex-center-end-column-nowrap width-200px">
          {data?.params?.includeDeliveryNotes && <div className="boldText3">{t('PDF.WITH_DELIVERY_NOTES')}</div>}
        </div>
      </div>
    );
  }, [
    data?.params?.end,
    data?.params?.includeDeliveryNotes,
    data?.params?.includeMoneyCollection,
    data?.params?.start,
    t,
  ]);

  return (
    <div className="a4-container-only-width">
      <div className="section margin-b-2-force">
        <div>
          <div className="flex-center-center-column-nowrap">
            <div className="normalText3 padding-t-10">
              {data?.params?.company?.title} - {t('CUSTOMERS_REPORT.VAT_NUMBER')}: {data?.params?.company?.vatNumber}
            </div>
            {getCustomerSection()}
            {getParamsSection()}
          </div>
          <div className="padding-t-4">
            <CustomerReportView data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};
